"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactPortal = require("react-portal");

var _H = _interopRequireDefault(require("../Typography/H4"));

var _Overlay = _interopRequireDefault(require("../Overlay"));

var _ThemeProvider = _interopRequireDefault(require("../ThemeProvider"));

var _mediaQueries = require("../../utils/media-queries");

var _utils = require("./utils");

var _styled = require("./styled");

var _propTypes = _interopRequireDefault(require("prop-types"));

var getCloseIconSize = function getCloseIconSize(_ref) {
  var isHandheld = _ref.isHandheld,
      size = _ref.size;

  if (isHandheld) {
    return 'normal';
  } else if ((0, _utils.isCompact)(size)) {
    return 'xxsmall';
  }

  return 'medium';
};

var getCloseIconColor = function getCloseIconColor(_ref2) {
  var size = _ref2.size;

  if ((0, _utils.isCompact)(size)) {
    return 'miscDarkest';
  }

  return 'textLight';
};

var Modal =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2["default"])(Modal, _React$PureComponent);

  function Modal() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Modal)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "closePortal", function () {
      if (_this.props.onClose) {
        _this.props.onClose();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleKeyDown", function (event) {
      if (event.keyCode === 27 && _this.props.closeOnEsc) {
        _this.closePortal();
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          size = _this$props.size,
          heading = _this$props.heading,
          renderHeader = _this$props.renderHeader,
          renderContent = _this$props.renderContent,
          footer = _this$props.footer,
          isOpen = _this$props.isOpen,
          closeOnOutsideClick = _this$props.closeOnOutsideClick,
          shouldRenderCloseIcon = _this$props.shouldRenderCloseIcon,
          isOnBottom = _this$props.isOnBottom,
          scrollFix = _this$props.scrollFix,
          onSubmitClick = _this$props.onSubmitClick,
          submitText = _this$props.submitText,
          closeButtonText = _this$props.closeButtonText,
          shouldRenderCloseButton = _this$props.shouldRenderCloseButton,
          onClose = _this$props.onClose;
      var defaultFooter = !isOnBottom ? _react["default"].createElement(_styled.Footer, null, onSubmitClick ? _react["default"].createElement(_styled.SubmitButton, {
        size: "large",
        onClick: onSubmitClick
      }, submitText) : null, shouldRenderCloseButton ? _react["default"].createElement(_styled.CloseButton, {
        onClick: onClose,
        size: "large",
        variant: "secondary"
      }, onSubmitClick ? closeButtonText : 'Закрыть') : null) : null;

      if (!isOpen) {
        return null;
      }

      return _react["default"].createElement(_reactPortal.Portal, {
        node: document && document.getElementById('portal')
      }, _react["default"].createElement(_ThemeProvider["default"], {
        className: "responsive"
      }, _react["default"].createElement(_Overlay["default"], {
        closePortal: closeOnOutsideClick && this.closePortal,
        isOnBottom: isOnBottom,
        scrollFix: scrollFix
      }, _react["default"].createElement(_styled.ModalContent, {
        size: size
      }, renderHeader((0, _objectSpread2["default"])({}, this.props, {
        children: heading
      })), shouldRenderCloseIcon ? _react["default"].createElement(_styled.CloseIcon, {
        modalSize: size,
        isOnBottom: isOnBottom,
        icon: _react["default"].createElement(_styled.StyledIcon, {
          name: "cross",
          fill: getCloseIconColor(this.props),
          onClick: this.closePortal,
          size: getCloseIconSize(this.props)
        })
      }) : null, renderContent(this.props), footer || defaultFooter))));
    }
  }]);
  return Modal;
}(_react["default"].PureComponent);

(0, _defineProperty2["default"])(Modal, "defaultProps", {
  heading: '',
  renderHeader: function renderHeader(_ref3) {
    var heading = _ref3.heading,
        size = _ref3.size;
    return heading ? _react["default"].createElement(_styled.Header, {
      size: size
    }, _react["default"].createElement(_H["default"], null, heading)) : null;
  },
  renderContent: function renderContent(props) {
    return _react["default"].createElement(_styled.Content, props);
  },
  footer: null,
  size: 'wide',
  closeOnOutsideClick: true,
  closeOnEsc: true,
  shouldRenderCloseIcon: true,
  isOnBottom: false,
  scrollFix: true,
  onSubmitClick: null,
  submitText: 'Продолжить',
  closeButtonText: 'Отменить',
  shouldRenderCloseButton: true
});
(0, _defineProperty2["default"])(Modal, "propTypes", {
  size: _propTypes["default"].oneOf(["wide", "compact", "thin"]),
  closeOnOutsideClick: _propTypes["default"].bool,
  closeOnEsc: _propTypes["default"].bool,
  shouldRenderCloseIcon: _propTypes["default"].bool,
  isOnBottom: _propTypes["default"].bool,
  scrollFix: _propTypes["default"].bool,
  onSubmitClick: _propTypes["default"].func,
  submitText: _propTypes["default"].string,
  closeButtonText: _propTypes["default"].string,
  shouldRenderCloseButton: _propTypes["default"].bool,
  footer: _propTypes["default"].node,
  onClose: _propTypes["default"].func.isRequired,
  heading: _propTypes["default"].string,
  renderHeader: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),
  renderContent: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),
  isOpen: _propTypes["default"].bool.isRequired
});

var _default = (0, _mediaQueries.withMedia)(Modal);

exports["default"] = _default;